var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dialog)?_c('v-card',{staticClass:"dialog"},[_c('v-card-text',{staticClass:"dialog-text"},[(_vm.event)?_c('convoyInfoPanel',{attrs:{"event":_vm.event}}):_vm._e()],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }